/*
 * Search results page (IO-5355) — see sections/main-search-results.liquid.
 *
 * URL state (also what the filter/sort forms serialise to):
 *   q, sort_by, page, filter.<searchanise attribute>=<value> (repeatable),
 *   filter.price.gte / filter.price.lte (whole euros).
 * Any other param (e.g. view, preview_theme_id) is carried through untouched.
 */
(function () {
    const root = document.querySelector('[data-search-results]');
    const configEl = document.querySelector('[data-search-results-config]');
    if (!root || !configEl) return;

    if (typeof FacetFiltersForm === 'undefined') return;

    const config = JSON.parse(configEl.textContent);
    const strings = config.strings;
    const perPage = parseInt(root.dataset.perPage, 10) || 15;
    const filterSearchThreshold = parseInt(root.dataset.filterSearchThreshold, 10) || 30;
    const bannedValues = (config.bannedFilterValues || '').toUpperCase();

    const aside = document.getElementById('main-collection-filters');
    const backdrop = document.getElementById('facets-mobile-backdrop');
    const grid = document.getElementById('product-grid');
    const countEl = root.querySelector('.collection-product-count');
    const sortSelect = document.getElementById('SortBy');
    const openButton = root.querySelector('.filter-open-button');
    const noticeEl = root.querySelector('[data-search-notice]');
    const paginationEl = root.querySelector('[data-search-pagination]');
    const collectionEl = root.querySelector('[data-search-collection]');
    const emptyEl = root.querySelector('[data-search-empty]');
    const emptyTextEl = root.querySelector('[data-search-empty-text]');
    const titleEl = document.querySelector('.collection-title-text');

    const SEARCH_API = 'https://searchserverapi1.com/getresults';
    const OWN_PARAMS = ['q', 'sort_by', 'page'];
    const FILTER_PREFIX = 'filter.';
    const PRICE_GTE = 'filter.price.gte';
    const PRICE_LTE = 'filter.price.lte';
    const DEFAULT_SORT = 'relevance';
    // Theme sort values → Searchanise sortBy/sortOrder. Mirrors the collection page's sort list.
    const SORTS = {
        'relevance': ['relevance', 'desc'],
        'best-selling': ['sales_amount', 'desc'],
        'price-ascending': ['price', 'asc'],
        'price-descending': ['price', 'desc'],
        'created-descending': ['created', 'desc']
    };
    const STAR_VALUES = {fivestar: 5, fourstar: 4, threestar: 3, twostar: 2, onestar: 1};

    const pluralRules = new Intl.PluralRules(document.documentElement.lang || 'lt');
    const responseCache = new Map();
    let currentState = null;
    let renderController = null;

    /* ── Searchanise config ─────────────────────────────────────────────── */

    function getApiKey() {
        const script = document.querySelector('script[src*="searchanise"][src*="init.js"]');
        return script ? new URL(script.src, location.href).searchParams.get('a') : null;
    }

    const apiKey = getApiKey();

    // The widget's dashboard config (Searchanise.templates) carries the per-market catalog ids,
    // the in-stock rule, locales and redirects. The section starts loading it inline
    // (window.kikaSearchaniseTemplates); fall back to loading it here.
    const templatesLoaded = window.kikaSearchaniseTemplates || new Promise(function (resolve) {
        if (window.Searchanise && window.Searchanise.templates) return resolve(window.Searchanise.templates);
        const script = document.createElement('script');
        script.src = 'https://searchanise-ef84.kxcdn.com/templates.' + apiKey + '.js';
        script.onload = function () { resolve((window.Searchanise && window.Searchanise.templates) || {}); };
        script.onerror = function () { resolve({}); };
        document.head.appendChild(script);
    });

    // It gates the first results request and is slow to arrive (seconds on a cold load), so the
    // fields used here are kept for the session and refreshed in the background.
    const TEMPLATE_FIELDS = ['ShopifyRegionCatalogs', 'ResultsShowOnlyInStock', 'ShopifyLocales', 'Redirects'];
    const templatesCacheKey = 'kikaSearchTemplates:' + apiKey;
    let cachedTemplates = null;
    try {
        cachedTemplates = JSON.parse(sessionStorage.getItem(templatesCacheKey));
    } catch (e) { /* storage unavailable */ }
    // Only trust an entry of the shape written below; anything else (an older release, a bad
    // write) falls back to the real config rather than searching without the market catalog.
    if (!cachedTemplates || typeof cachedTemplates.ShopifyLocales !== 'object' || !('ShopifyRegionCatalogs' in cachedTemplates)) {
        cachedTemplates = null;
    }

    templatesLoaded.then(function (templates) {
        if (!templates || !templates.ShopifyLocales) return;
        const picked = {};
        TEMPLATE_FIELDS.forEach(function (field) { picked[field] = templates[field]; });
        try {
            sessionStorage.setItem(templatesCacheKey, JSON.stringify(picked));
        } catch (e) { /* storage unavailable */ }
    });

    const templatesReady = cachedTemplates ? Promise.resolve(cachedTemplates) : templatesLoaded;

    function storageGet(key) {
        try {
            if (window.Searchanise && Searchanise.GetLocalStorage) return Searchanise.GetLocalStorage(key);
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            return null;
        }
    }

    function storageSet(key, value) {
        try {
            if (window.Searchanise && Searchanise.SetLocalStorage) return Searchanise.SetLocalStorage(key, value);
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) { /* storage unavailable — analytics only */ }
    }

    // Same per-query uuid store the widget uses, so searches from this page land in the same
    // Searchanise analytics bucket (and later orders can be attributed to them).
    function getSearchUuid(query) {
        const now = Date.now();
        const saved = storageGet('snize_saved_search_queries') || {};
        if (saved[query] && saved[query].uuid && saved[query].expires > now) return saved[query].uuid;
        const uuid = (window.Searchanise && Searchanise.GenerateSessionId)
            ? Searchanise.GenerateSessionId()
            : (crypto.randomUUID ? crypto.randomUUID() : String(now) + Math.random().toString(16).slice(2));
        saved[query] = {expires: now + 72e5, uuid: uuid};
        storageSet('snize_saved_search_queries', saved);
        return uuid;
    }

    /* ── State ──────────────────────────────────────────────────────────── */

    function parseState(searchParams) {
        const params = new URLSearchParams(searchParams);
        const state = {
            q: (params.get('q') || '').trim(),
            sort: SORTS[params.get('sort_by')] ? params.get('sort_by') : DEFAULT_SORT,
            page: Math.max(1, parseInt(params.get('page'), 10) || 1),
            filters: {},
            priceGte: params.get(PRICE_GTE) || '',
            priceLte: params.get(PRICE_LTE) || '',
            extra: []
        };
        params.forEach(function (value, key) {
            if (key === PRICE_GTE || key === PRICE_LTE) return;
            if (key.indexOf(FILTER_PREFIX) === 0) {
                if (!value) return;
                const attribute = key.slice(FILTER_PREFIX.length);
                (state.filters[attribute] = state.filters[attribute] || []).push(value);
            } else if (OWN_PARAMS.indexOf(key) === -1) {
                state.extra.push([key, value]);
            }
        });
        return state;
    }

    function stateToParams(state, overrides) {
        const s = Object.assign({}, state, overrides || {});
        const params = new URLSearchParams();
        if (s.q) params.append('q', s.q);
        if (s.sort !== DEFAULT_SORT) params.append('sort_by', s.sort);
        Object.keys(s.filters).forEach(function (attribute) {
            s.filters[attribute].forEach(function (value) { params.append(FILTER_PREFIX + attribute, value); });
        });
        if (s.priceGte) params.append(PRICE_GTE, s.priceGte);
        if (s.priceLte) params.append(PRICE_LTE, s.priceLte);
        if (s.page > 1) params.append('page', s.page);
        s.extra.forEach(function (pair) { params.append(pair[0], pair[1]); });
        return params.toString();
    }

    function activeFilterCount(state) {
        return Object.keys(state.filters).reduce(function (sum, key) { return sum + state.filters[key].length; }, 0);
    }

    /* ── Searchanise request ────────────────────────────────────────────── */

    function buildRequest(state, templates, options) {
        const params = new URLSearchParams({
            api_key: apiKey,
            q: state.q,
            sortBy: SORTS[state.sort][0],
            sortOrder: SORTS[state.sort][1],
            startIndex: String(options.countOnly ? 0 : (state.page - 1) * perPage),
            maxResults: String(options.countOnly ? 0 : perPage),
            items: 'true',
            facets: 'true',
            facetsShowUnavailableOptions: 'false',
            categories: 'false',
            pages: 'false',
            suggestions: 'false',
            queryCorrection: 'true',
            output: 'json'
        });
        if (!options.countOnly) params.set('searchUuid', getSearchUuid(state.q));
        try {
            params.set('timeZoneName', Intl.DateTimeFormat().resolvedOptions().timeZone);
        } catch (e) { /* optional */ }

        if (templates.ResultsShowOnlyInStock === 'Y') params.set('restrictBy[quantity]', '1|');

        const country = window.Shopify && Shopify.country;
        const catalogs = templates.ShopifyRegionCatalogs && country && templates.ShopifyRegionCatalogs[country];
        if (catalogs && catalogs.length) params.set('restrictBy[shopify_market_catalogs]', catalogs.join('|'));

        // Only non-primary locales get translated fields; sending the primary locale switches
        // facet titles to English.
        const locale = window.Shopify && Shopify.locale;
        const localeInfo = templates.ShopifyLocales && locale && templates.ShopifyLocales[locale];
        if (localeInfo && !localeInfo.primary) params.set('translationLanguage', locale);

        Object.keys(state.filters).forEach(function (attribute) {
            params.set('restrictBy[' + attribute + ']', state.filters[attribute].join('|'));
        });
        if (state.priceGte || state.priceLte) params.set('restrictBy[price]', (state.priceGte || '') + ',' + (state.priceLte || ''));

        return SEARCH_API + '?' + params.toString();
    }

    function fetchResults(state, options, signal) {
        return templatesReady.then(function (templates) {
            const url = buildRequest(state, templates, options);
            const cacheKey = url.replace(/&searchUuid=[^&]*/, '');
            if (responseCache.has(cacheKey)) return responseCache.get(cacheKey);
            return fetch(url, {signal: signal})
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (!data.error) responseCache.set(cacheKey, data);
                    return data;
                });
        });
    }

    /* ── Cards ──────────────────────────────────────────────────────────── */

    // One Shopify search request renders every result with the real product-card snippet.
    function fetchCards(items, signal) {
        if (!items.length) return Promise.resolve([]);
        const handles = items.map(function (item) {
            return (item.link || '').split('?')[0].split('/').pop();
        }).filter(Boolean);
        const params = new URLSearchParams({
            q: handles.map(function (handle) { return 'handle:' + handle; }).join(' OR '),
            type: 'product',
            section_id: config.cardsSection
        });
        return fetch(config.searchUrl + '?' + params.toString(), {signal: signal})
            .then(function (response) { return response.text(); })
            .then(function (html) {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const cardsById = {};
                doc.querySelectorAll('.product-card[data-product-id]').forEach(function (card) {
                    cardsById[card.dataset.productId] = card;
                });
                return items.map(function (item) { return cardsById[item.product_id]; }).filter(Boolean);
            });
    }

    /* ── Markup ─────────────────────────────────────────────────────────── */

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    const CHEVRON_SVG = '<svg class="facets-new__chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const PILL_X_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9 9" fill="none" aria-hidden="true"><path d="M8 2L2 8M2 2l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    const CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    const SEARCH_SVG = '<svg class="facets-new__filter-search-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    const STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M6.87979 1.37C6.90595 1.31715 6.94636 1.27266 6.99646 1.24156C7.04657 1.21045 7.10436 1.19397 7.16334 1.19397C7.22231 1.19397 7.28011 1.21045 7.33021 1.24156C7.38031 1.27266 7.42072 1.31715 7.44688 1.37L8.82581 4.16308C8.91665 4.34692 9.05075 4.50597 9.21658 4.62658C9.38242 4.74719 9.57505 4.82575 9.77793 4.85553L12.8617 5.30682C12.9201 5.31528 12.975 5.33993 13.0202 5.37797C13.0654 5.41601 13.099 5.46593 13.1172 5.52208C13.1355 5.57822 13.1377 5.63836 13.1235 5.69568C13.1094 5.75301 13.0795 5.80523 13.0372 5.84645L10.8071 8.01812C10.66 8.16144 10.5499 8.33836 10.4864 8.53365C10.4229 8.72894 10.4077 8.93674 10.4423 9.13917L10.9688 12.2074C10.9791 12.2658 10.9728 12.326 10.9506 12.381C10.9284 12.4359 10.8912 12.4836 10.8432 12.5184C10.7952 12.5533 10.7384 12.574 10.6792 12.5781C10.6201 12.5822 10.5609 12.5696 10.5086 12.5417L7.75192 11.0924C7.57028 10.997 7.36819 10.9471 7.16304 10.9471C6.95788 10.9471 6.7558 10.997 6.57416 11.0924L3.81809 12.5417C3.76576 12.5694 3.7067 12.5819 3.64763 12.5777C3.58857 12.5735 3.53187 12.5528 3.48398 12.518C3.43609 12.4831 3.39894 12.4356 3.37675 12.3807C3.35455 12.3258 3.34821 12.2658 3.35845 12.2074L3.88435 9.13976C3.91909 8.93724 3.90404 8.72931 3.8405 8.5339C3.77696 8.33849 3.66683 8.16147 3.51962 8.01812L1.28946 5.84705C1.24683 5.80588 1.21663 5.75356 1.20228 5.69607C1.18794 5.63857 1.19003 5.5782 1.20832 5.52183C1.22661 5.46546 1.26037 5.41537 1.30574 5.37725C1.35111 5.33913 1.40628 5.31452 1.46496 5.30622L4.54815 4.85553C4.75126 4.82598 4.94415 4.74752 5.11021 4.6269C5.27628 4.50627 5.41055 4.3471 5.50146 4.16308L6.87979 1.37Z" fill="#FDCC0D" stroke="#FDCC0D" stroke-width="0.916667" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function isRatingFacet(facet) {
        return /review|rating/.test(facet.attribute);
    }

    function isSelected(state, attribute, value) {
        return (state.filters[attribute] || []).indexOf(value) !== -1;
    }

    // Builds the same DOM as snippets/facets-new.liquid, so base-new.css styles it unchanged.
    function renderSidebar(state, facets) {
        const total = activeFilterCount(state);
        const clearParams = stateToParams(state, {filters: {}, priceGte: '', priceLte: '', page: 1});
        let html = '<facet-filters-form><form id="FacetFiltersForm" class="facets-new">';
        html += '<input type="hidden" name="q" value="' + escapeHtml(state.q) + '">';

        html += '<div class="facets-new__active-card"><div class="facets-new__active-header"><div class="facets-new__active-header-left">';
        html += '<span class="facets-new__active-title">' + escapeHtml(strings.filtersTitle) + (total > 0 ? ' (' + total + ')' : '') + '</span>';
        if (total > 0) {
            html += '<facet-remove class="facets-new__header-clear"><a href="?' + escapeHtml(clearParams) + '" class="facets-new__clear-all">' + escapeHtml(strings.clearAll) + '</a></facet-remove>';
        }
        html += '</div><button type="button" class="facets-mobile-header__close" id="facets-mobile-close-btn" aria-label="' + escapeHtml(strings.closeFilters) + '">' + CLOSE_SVG + '</button></div>';

        if (total > 0) {
            html += '<div class="facets-new__active-pills">';
            facets.forEach(function (facet) {
                (state.filters[facet.attribute] || []).forEach(function (value) {
                    const remaining = {};
                    Object.keys(state.filters).forEach(function (key) {
                        remaining[key] = state.filters[key].filter(function (v) { return key !== facet.attribute || v !== value; });
                    });
                    // Rating pills use the same star icons as the rating checkboxes below.
                    const labelHtml = isRatingFacet(facet) && STAR_VALUES[value]
                        ? '<span class="facets-new__checkbox-stars">' + STAR_SVG.repeat(STAR_VALUES[value]) + '</span>'
                        : escapeHtml(value);
                    html += '<facet-remove><a href="?' + escapeHtml(stateToParams(state, {filters: remaining, page: 1})) + '" class="facets-new__active-pill">' + labelHtml + PILL_X_SVG + '</a></facet-remove>';
                });
            });
            html += '</div>';
        }
        html += '</div>';

        html += '<div class="facets-new__sidebar">';
        facets.forEach(function (facet) {
            const groupId = 'FacetGroup-' + escapeHtml(facet.attribute) + '-' + escapeHtml(config.sectionId);
            const title = escapeHtml(facet.title);

            if (facet.type === 'slider') {
                const bucket = facet.buckets && facet.buckets[0];
                if (!bucket) return;
                const rangeMax = Math.ceil(parseFloat(bucket.to));
                if (!(rangeMax > 0) || parseFloat(bucket.to) <= parseFloat(bucket.from)) return;
                html += '<details class="facets-new__group" id="' + groupId + '" open>';
                html += '<summary class="facets-new__group-header"><span class="facets-new__group-label">' + title + '</span>' + CHEVRON_SVG + '</summary>';
                html += '<div class="facets-new__group-body"><div class="facets-new__range-wrapper"><div class="facets-new__range-track">&nbsp;</div>';
                html += '<input class="facets-new__range-input facets-new__range-input--min" type="range" min="0" max="' + rangeMax + '" value="' + escapeHtml(state.priceGte || 0) + '" step="1" aria-label="' + escapeHtml(strings.minPriceLabel || 'Min price') + '">';
                html += '<input class="facets-new__range-input facets-new__range-input--max" type="range" min="0" max="' + rangeMax + '" value="' + escapeHtml(state.priceLte || rangeMax) + '" step="1" aria-label="' + escapeHtml(strings.maxPriceLabel || 'Max price') + '">';
                html += '</div><price-range class="facets-new__price-range"><div class="facets-new__price-inputs">';
                html += '<div class="facets-new__price-field"><input class="facets-new__price-input" name="' + PRICE_GTE + '"' + (state.priceGte ? ' value="' + escapeHtml(state.priceGte) + '"' : '') + ' type="number" placeholder="0" min="0" step="1" inputmode="numeric" max="' + rangeMax + '"></div>';
                html += '<span class="facets-new__price-sep">—</span>';
                html += '<div class="facets-new__price-field"><input class="facets-new__price-input" name="' + PRICE_LTE + '"' + (state.priceLte ? ' value="' + escapeHtml(state.priceLte) + '"' : '') + ' type="number" placeholder="' + rangeMax + '" min="0" step="1" inputmode="numeric" max="' + rangeMax + '"></div>';
                html += '</div></price-range></div></details>';
                return;
            }

            const rating = isRatingFacet(facet);
            const buckets = (facet.buckets || []).filter(function (bucket) {
                const selected = isSelected(state, facet.attribute, bucket.value);
                if (bannedValues && bannedValues.indexOf(String(bucket.value).toUpperCase()) !== -1) return false;
                if (rating && (!STAR_VALUES[bucket.value] || (Number(bucket.count) === 0 && !selected))) return false;
                return true;
            });
            if (!buckets.length) return;

            html += '<details class="facets-new__group" id="' + groupId + '" open>';
            html += '<summary class="facets-new__group-header"><span class="facets-new__group-label">' + title + '</span>' + CHEVRON_SVG + '</summary>';
            html += '<div class="facets-new__group-body' + (buckets.length > 8 ? ' facets-new__group-body--scroll' : '') + '">';
            if (buckets.length > filterSearchThreshold) {
                html += '<div class="facets-new__filter-search-wrapper">' + SEARCH_SVG + '<input type="text" class="facets-new__filter-search" placeholder="' + escapeHtml(strings.searchFiltersPlaceholder) + '" autocomplete="off" aria-label="' + escapeHtml(strings.searchFiltersLabel) + '"></div>';
            }
            html += '<fieldset class="facets-new__fieldset"><legend class="visually-hidden">' + title + '</legend>';
            buckets.forEach(function (bucket) {
                const selected = isSelected(state, facet.attribute, bucket.value);
                const disabled = Number(bucket.count) === 0 && !selected;
                html += '<label class="facets-new__checkbox-label' + (disabled ? ' facets-new__checkbox-label--disabled' : '') + '">';
                html += '<input type="checkbox" name="' + escapeHtml(FILTER_PREFIX + facet.attribute) + '" value="' + escapeHtml(bucket.value) + '"' + (selected ? ' checked' : '') + (disabled ? ' disabled' : '') + '>';
                html += '<span class="facets-new__checkbox-custom"></span>';
                if (rating) {
                    html += '<span class="facets-new__checkbox-stars">' + STAR_SVG.repeat(STAR_VALUES[bucket.value]) + '</span>';
                } else {
                    html += '<span class="facets-new__checkbox-text">' + escapeHtml(bucket.title || bucket.value) + '</span>';
                }
                html += '<span class="facets-new__checkbox-count">(' + escapeHtml(bucket.count) + ')</span></label>';
            });
            html += '</fieldset></div></details>';
        });
        html += '</div>';

        html += '<div class="facets-new__mobile-footer">';
        html += '<button type="button" class="facets-new__mobile-clear" id="facets-mobile-clear-btn"' + (total > 0 ? '' : ' disabled') + '>' + escapeHtml(strings.clearAll) + '</button>';
        html += '<button type="button" class="facets-new__mobile-apply" id="facets-mobile-apply-btn">' + escapeHtml(strings.filterButton) + '</button>';
        html += '</div></form></facet-filters-form>';

        aside.innerHTML = html;
    }

    const ARROW_PREV_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none"><path d="M15.0109 6.23458H5.00928M5.00928 6.23458L10.0101 11.2354M5.00928 6.23458L10.0101 1.23291" stroke="#183306" stroke-width="1.43174" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const ARROW_NEXT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none"><path d="M5.00911 5.76811L15.0107 5.7681M15.0107 5.7681L10.0099 0.767291M15.0107 5.7681L10.0099 10.7698" stroke="#183306" stroke-width="1.43174" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // Same markup as snippets/pagination.liquid; page links are intercepted by the click handler.
    function renderPagination(state, totalItems) {
        const pages = Math.ceil(totalItems / perPage);
        if (pages <= 1) {
            paginationEl.innerHTML = '';
            return;
        }
        const current = Math.min(state.page, pages);
        const pageHref = function (n) { return '?' + escapeHtml(stateToParams(state, {page: n})); };
        const pageLabel = function (n) { return escapeHtml(strings.paginationPage.replace('[number]', n)); };

        let parts = '';
        let last = 0;
        for (let n = 1; n <= pages; n++) {
            if (n !== 1 && n !== pages && Math.abs(n - current) > 2) continue;
            if (n - last > 1) parts += '<li><span class="pagination__item">&hellip;</span></li>';
            if (n === current) {
                parts += '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="' + pageLabel(n) + '">' + n + '</a></li>';
            } else {
                parts += '<li><a href="' + pageHref(n) + '" class="pagination__item link" data-page="' + n + '" aria-label="' + pageLabel(n) + '">' + n + '</a></li>';
            }
            last = n;
        }

        let html = '<div class="pagination-wrapper" data-snippet="pagination"><nav class="pagination" role="navigation" aria-label="' + escapeHtml(strings.paginationLabel) + '"><div class="pagination__row">';
        html += '<div class="pagination__slot pagination__slot--prev">';
        html += current > 1
            ? '<a href="' + pageHref(current - 1) + '" data-page="' + (current - 1) + '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="' + escapeHtml(strings.paginationPrevious) + '">' + ARROW_PREV_SVG + '</a>'
            : '<a class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="' + escapeHtml(strings.paginationPrevious) + '" style="opacity: 0.5;">' + ARROW_PREV_SVG + '</a>';
        html += '</div><ul class="pagination__pages list-unstyled" role="list">' + parts + '</ul>';
        html += '<div class="pagination__slot pagination__slot--next">';
        if (current < pages) {
            html += '<a href="' + pageHref(current + 1) + '" data-page="' + (current + 1) + '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="' + escapeHtml(strings.paginationNext) + '">' + ARROW_NEXT_SVG + '</a>';
        }
        html += '</div></div></nav></div>';
        paginationEl.innerHTML = html;
    }

    function formatCount(count) {
        const template = pluralRules.select(count) === 'one' ? strings.productCount.one : strings.productCount.other;
        return template.replace('[count]', count);
    }

    function updateCounts(state, totalItems) {
        const total = activeFilterCount(state);
        countEl.dataset.count = totalItems;
        countEl.textContent = formatCount(totalItems);
        openButton.textContent = strings.filtersTitle + (total > 0 ? ' (' + total + ')' : '');
        syncApplyCount(totalItems);
    }

    function syncApplyCount(count) {
        const button = document.getElementById('facets-mobile-apply-btn');
        if (button) button.textContent = strings.filterButton + ' (' + count + ')';
    }

    /* ── Render ─────────────────────────────────────────────────────────── */

    function render(searchParams, updateUrl) {
        const state = parseState(searchParams);
        // The filter/sort forms carry neither the query (when the sidebar is empty or cleared) nor
        // params this page doesn't own (view, preview_theme_id…) — keep those from the current state.
        if (currentState) {
            if (!state.q) state.q = currentState.q;
            if (!state.extra.length) state.extra = currentState.extra;
        }
        currentState = state;

        if (updateUrl) {
            const params = stateToParams(state);
            history.pushState({searchParams: params}, '', location.pathname + (params ? '?' + params : ''));
        }

        sortSelect.value = state.sort;
        if (titleEl) titleEl.textContent = state.q ? strings.title + ': ' + state.q : strings.title;

        if (renderController) renderController.abort();
        renderController = new AbortController();
        const signal = renderController.signal;
        grid.setAttribute('aria-busy', 'true');

        if (!state.q) {
            showEmpty(state, 0);
            aside.innerHTML = '';
            updateCounts(state, 0);
            return Promise.resolve();
        }

        return fetchResults(state, {}, signal)
            .then(function (data) {
                if (data.error) throw new Error('Searchanise: ' + data.error);
                const items = (data.items || []).filter(function (item) { return item.product_id; });
                return fetchCards(items, signal).then(function (cards) { return {data: data, cards: cards}; });
            })
            .then(function (result) {
                const data = result.data;
                const totalItems = Number(data.totalItems) || 0;

                if (data.correctedQuery) {
                    noticeEl.textContent = strings.correctedQuery.replace('[query]', data.correctedQuery);
                    noticeEl.hidden = false;
                } else {
                    noticeEl.hidden = true;
                }

                renderSidebar(state, data.facets || []);
                updateCounts(state, totalItems);

                if (!result.cards.length) {
                    showEmpty(state, totalItems);
                } else {
                    emptyEl.hidden = true;
                    collectionEl.hidden = false;
                    grid.replaceChildren.apply(grid, result.cards.map(function (card) { return document.importNode(card, true); }));
                    renderPagination(state, totalItems);
                }
                grid.setAttribute('aria-busy', 'false');

                document.dispatchEvent(new CustomEvent('facets:rendered'));
                document.dispatchEvent(new CustomEvent('product-cards:rendered'));
            })
            .catch(function (error) {
                if (error.name === 'AbortError') return;
                grid.setAttribute('aria-busy', 'false');
                console.error(error);
                showEmpty(state, 0);
            });
    }

    function showEmpty(state, totalItems) {
        collectionEl.hidden = true;
        emptyEl.hidden = false;
        paginationEl.innerHTML = '';
        grid.replaceChildren();
        grid.setAttribute('aria-busy', 'false');
        const filtered = activeFilterCount(state) > 0 || state.priceGte || state.priceLte;
        emptyTextEl.textContent = filtered && !totalItems
            ? strings.noResultsFiltered
            : strings.noResults.replace('[terms]', state.q);
    }

    // facets.js drives the forms (serialise, debounce, <facet-remove>, popstate); only its fetch
    // step is replaced — it would otherwise request a Liquid section that has no results to render.
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        render(searchParams, updateURLHash !== false);
    };

    /* ── Pagination & click tracking ────────────────────────────────────── */

    paginationEl.addEventListener('click', function (event) {
        const link = event.target.closest('a[data-page]');
        if (!link) return;
        event.preventDefault();
        FacetFiltersForm.renderPage(stateToParams(currentState, {page: Number(link.dataset.page)}));
        root.scrollIntoView({behavior: 'smooth', block: 'start'});
    });

    // Lets Searchanise attribute the click (and a later order) to this search, as its widget does.
    function trackClick(event) {
        const card = event.target.closest('#product-grid .product-card[data-product-id]');
        if (!card || !currentState || !(window.Searchanise && Searchanise.AddClickToQueue)) return;
        Searchanise.AddClickToQueue({product_id: card.dataset.productId, query: currentState.q});
    }

    grid.addEventListener('mousedown', trackClick);
    grid.addEventListener('touchstart', trackClick, {passive: true});

    /* ── Filter value search (from snippets/facets-new.liquid) ──────────── */

    aside.addEventListener('input', function (event) {
        if (!event.target.classList.contains('facets-new__filter-search')) return;
        event.stopPropagation(); // keep it from reaching FacetFiltersForm's submit
        const query = event.target.value.trim().toLowerCase();
        const body = event.target.closest('.facets-new__group-body');
        body.querySelectorAll('.facets-new__checkbox-label').forEach(function (label) {
            const textEl = label.querySelector('.facets-new__checkbox-text');
            const text = (textEl ? textEl.textContent : label.textContent).trim().toLowerCase();
            label.classList.toggle('facets-new__checkbox-label--hidden', query !== '' && !text.includes(query));
        });
    }, true);

    /* ── Mobile drawer (mirrors sections/main-collection-product-grid.liquid) ── */

    let savedSidebarHtml = null;
    let filterApplied = false;
    let previewTimer = null;
    let previewController = null;

    function serializeForms() {
        const parts = [];
        document.querySelectorAll('facet-filters-form form').forEach(function (form) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
                parts.push(new URLSearchParams(new FormData(form)).toString());
            }
        });
        return parts.filter(Boolean).join('&');
    }

    function openFilters() {
        aside.classList.add('is-open');
        backdrop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        openButton.setAttribute('aria-expanded', 'true');
        savedSidebarHtml = aside.innerHTML;
        filterApplied = false;
    }

    function closeFilters() {
        aside.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        document.body.style.overflow = '';
        openButton.setAttribute('aria-expanded', 'false');
        if (previewController) previewController.abort();
        clearTimeout(previewTimer);
        if (!filterApplied && savedSidebarHtml !== null) {
            aside.innerHTML = savedSidebarHtml;
            document.dispatchEvent(new CustomEvent('facets:rendered'));
        }
        savedSidebarHtml = null;
        filterApplied = false;
    }

    function applyFilters(searchParams) {
        filterApplied = true;
        FacetFiltersForm.renderPage(searchParams);
        closeFilters();
    }

    document.addEventListener('click', function (event) {
        if (event.target.closest('.filter-open-button')) {
            openFilters();
        } else if (event.target.closest('#facets-mobile-close-btn')) {
            closeFilters();
        } else if (event.target === backdrop) {
            closeFilters();
        } else if (event.target.closest('#facets-mobile-apply-btn')) {
            applyFilters(serializeForms());
        } else if (event.target.closest('#facets-mobile-clear-btn')) {
            applyFilters(stateToParams(currentState, {filters: {}, priceGte: '', priceLte: '', page: 1}));
        }
    });

    // Mobile preview: re-render the sidebar (counts, pills) as filters change, without touching the grid.
    function previewFilters() {
        if (previewController) previewController.abort();
        previewController = new AbortController();
        const state = parseState(serializeForms());
        if (!state.q) state.q = currentState.q;
        fetchResults(state, {countOnly: true}, previewController.signal)
            .then(function (data) {
                if (data.error || !aside.classList.contains('is-open')) return;
                renderSidebar(state, data.facets || []);
                document.dispatchEvent(new CustomEvent('facets:rendered'));
                syncApplyCount(Number(data.totalItems) || 0);
            })
            .catch(function (error) {
                if (error.name !== 'AbortError') console.error(error);
            });
    }

    document.addEventListener('input', function (event) {
        if (window.innerWidth >= 992) return;
        if (!event.target.closest('#FacetFiltersForm')) return;
        if (event.target.classList.contains('facets-new__filter-search')) return;
        clearTimeout(previewTimer);
        previewTimer = setTimeout(previewFilters, 500);
    });

    document.addEventListener('change', function (event) {
        if (window.innerWidth >= 992 || event.target !== sortSelect) return;
        applyFilters(serializeForms());
    });

    document.addEventListener('keydown', function (event) {
        if (event.target.closest('.filter-open-button') && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            openFilters();
        }
        if (event.key === 'Escape' && aside.classList.contains('is-open')) closeFilters();
    });

    /* ── Start ──────────────────────────────────────────────────────────── */

    // Merchandising redirects from the Searchanise dashboard. The widget applies them on submit
    // from the header; this covers direct links and the /search → results-page redirect.
    templatesReady.then(function (templates) {
        const query = (parseState(location.search).q || '').toLowerCase();
        const redirects = templates.Redirects || {};
        const target = query && Object.keys(redirects).find(function (url) {
            return (redirects[url] || []).some(function (phrase) { return String(phrase).toLowerCase() === query; });
        });
        if (target) {
            location.replace(target);
            return;
        }
        render(location.search, false);
    });
})();
